var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8474,
    cy: 14.0545,
    r: 13.9451,
    fill: "#4BCD5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4488 11.2424C20.6939 11.4875 20.6939 11.8848 20.4488 12.1299L14.5919 17.9868C14.3468 18.2319 13.9495 18.2319 13.7044 17.9868L10.3576 14.64C10.1126 14.3949 10.1126 13.9976 10.3576 13.7525C10.6027 13.5074 11 13.5074 11.2451 13.7525L14.1482 16.6556L19.5614 11.2424C19.8064 10.9973 20.2038 10.9973 20.4488 11.2424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedProgram);
export default __webpack_public_path__ + "static/media/selectedProgram.d63f46d81e0c66e9e98f1d8aed9993cc.svg";
export { ForwardRef as ReactComponent };